export default __webpack_public_path__ + "static/media/investment.7ef67666.svg";